import * as React from 'react';
import { List, Card, Divider } from '@mui/material';
import { HeroBanner } from '@brightlayer-ui/react-components/core';
import { MetricHero } from '../MetricHero';
import { ChannelDatum } from '../../types';
import { ActionRow } from '../OverviewCard/ActionRow';
import { useLanguageLocale } from '../../hooks/language-locale-hooks';
import { AppRoute } from '../../routes';
import { SiteReadingCardMetricListItem } from '../SiteReadingCardMetricListItem';
import { Data, isDataLoaded } from '../../types/data-providers';
import { DataIndicators } from '../DataIndicators';
import { ConnectionHero } from '../ConnectionHero';
import { BatteryHero } from '../BatteryHero/BatteryHero';

const HeroCardCount = 2;
//const TotalCount = 14;

export const SiteReadingCard: React.FC<{
    channelData: Data<ChannelDatum[]>;
    onlineStatusData: Data<object | undefined>;
    batteryStatusData: Data<boolean | null>;
    readingsAppRoute: AppRoute;
    testId?: string;
}> = (props) => {
    const { t } = useLanguageLocale();
    const priorityChannelData: ChannelDatum[] = [
        ...(isDataLoaded(props.channelData) ? props.channelData.value.slice(0, HeroCardCount) : []),
    ];

    const otherChannelData = isDataLoaded(props.channelData)
        ? props.channelData.value.slice(HeroCardCount, props.channelData.value.length)
        : [];

    const isEmpty = isDataLoaded(props.channelData) ? props.channelData.value.length === 0 : true;

    return (
        <Card data-testid={props.testId} style={{ width: '360px' }}>
            <>
                <HeroBanner>
                    {priorityChannelData.map((channelDatum, index) => (
                        <MetricHero testId="channel-data-hero" key={index} channelDatum={channelDatum} />
                    ))}

                    {isDataLoaded(props.batteryStatusData) && props.batteryStatusData.value !== null && (
                        <div style={{ flex: '1 1 0px' }}>
                            <BatteryHero siteBatteryStatus={props.batteryStatusData} testId="battery-data-hero" />
                        </div>
                    )}

                    <div style={{ flex: '1 1 0px' }}>
                        <ConnectionHero onlineStatusData={props.onlineStatusData} testId="connection-data-hero" />
                    </div>
                </HeroBanner>
                <Divider />
                <DataIndicators
                    emptyIcon="Maintenance"
                    emptyMessage={t('DASHBOARD.NO_DATA')}
                    errorMessage={t('DASHBOARD.ERROR_LOADING_DATA')}
                    data={props.channelData}
                    isEmpty={isEmpty}
                    inline
                />

                {!isEmpty && (
                    <>
                        <List disablePadding>
                            {otherChannelData.map((channelDatum, index) => (
                                <SiteReadingCardMetricListItem
                                    testId="channel-data-list-item"
                                    key={index}
                                    value={channelDatum}
                                    showIcon
                                    isLastItem={index + 1 === otherChannelData.length}
                                />
                            ))}
                        </List>
                        <Divider />
                        <ActionRow
                            label={t('DASHBOARD.SITE_DETAILS.READING_CARDS.VIEW_ALL')}
                            appRoute={props.readingsAppRoute}
                        />
                    </>
                )}
            </>
        </Card>
    );
};
